module.exports = __webpack_public_path__ + "img/Slagboom-met-auto.a0d7ff9b.svg";